import { call, put, takeEvery } from "redux-saga/effects";
import { sagaTypes } from "./types";
import { IData, IDataPage } from "../../interfaces/common";
import { IAction } from "../utils";
import { IModel } from "../../interfaces/product";
import {
  getModelsAction,
  setSizePageAction,
  getMoreModelsAction,
  getModelAction,
} from "./action";
import { getModel, getModels } from "../../api/models";

export function* getModelsWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<IModel[]> = yield call(getModels, payload as string);
  yield put(getModelsAction(res?.data?.items || []));
  if (res?.data) {
    const { pageSize, totalPages, totalCount, pageIndex } = res?.data;
    yield put(
      setSizePageAction({ pageSize, totalPages, totalCount, pageIndex })
    );
  }
}

export function* getMoreModelsWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<IModel[]> = yield call(getModels, payload as string);
  yield put(getMoreModelsAction(res?.data?.items || []));
  if (res?.data) {
    const { pageSize, totalPages, totalCount, pageIndex } = res?.data;
    yield put(
      setSizePageAction({ pageSize, totalPages, totalCount, pageIndex })
    );
  }
}

export function* getModelWorkerSaga({ payload }: IAction<string>) {
  const res: IData<IModel> = yield call(getModel, payload as string);
  yield put(getModelAction(res?.data));
}

export function* modelsWatcherSaga() {
  yield takeEvery(sagaTypes?.GET_ALL_MODELS, getModelsWorkerSaga);
  yield takeEvery(sagaTypes?.GET_MORE_MODELS, getMoreModelsWorkerSaga);
  yield takeEvery(sagaTypes?.GET_MODEL, getModelWorkerSaga);
}
